import Dropdown from "./Dropdown"
(function(){
    const DROPDOWN_CLASS = "dropdown"
    document.querySelectorAll(`.${DROPDOWN_CLASS}`).forEach((dd) => dd && new Dropdown(dd).init())
})()